import { combineDucks } from "lib/utils/duck";

import ReviewsListView from "./ReviewsListView/index";
import EditReviewModal from "./EditReviewModal/index";

export default combineDucks({
  ReviewsListView,
  EditReviewModal,
});



// WEBPACK FOOTER //
// ./src/modules/reviews/index.js